import { RequestCheckpoint } from '../Models/checkpoint';
import { addToSummarize } from './url-creator';

export const findMaxDownloadSpeed = (checkpoints) => {
    const downloadedCheckpoints = transformCheckpoints(checkpoints);

    if(downloadedCheckpoints == undefined) {
        return;
    }

    return Math.max(...downloadedCheckpoints).toFixed(2);
}

export const findAverageDownloadSpeed = (checkpoints) => {
    let downloadedCheckpoints = transformCheckpoints(checkpoints);

    if(downloadedCheckpoints == undefined) {
        return
    }

    downloadedCheckpoints = downloadedCheckpoints.reduce((previous, current) => previous+current,0) / downloadedCheckpoints.length;
    
    return downloadedCheckpoints.toFixed(2);
}

// transfer checkpoints to mbit/sec from event info

export const summarizeDownloadSpeed = (arrayOfDownloadSpeeds, pingIndex, currentHost, viewManager, baseCheckpoints) => {
    const 
        averageDownloadSpeed = findAverageDownloadSpeed(baseCheckpoints),
        maxDownloadSpeed = findMaxDownloadSpeed(baseCheckpoints); 

    addToSummarize(currentHost.hostName, pingIndex, averageDownloadSpeed, maxDownloadSpeed)

    viewManager.updateTable(currentHost.hostName, pingIndex, averageDownloadSpeed, maxDownloadSpeed);
    viewManager.updateServerRequestStatus(currentHost.hostName, pingIndex, "Finished");
}


const transformCheckpoints = (checkpoints) => {
    if (checkpoints == undefined) {
        return
    }

    let
        downloadCheckpoints = checkpoints,
        loadedFromLastCheckpoint,
        timeFromLastCheckpoint;

    return downloadCheckpoints = downloadCheckpoints
    .map((checkpoint, checkpointIndex) => {
        if (checkpointIndex > 0) {
            loadedFromLastCheckpoint = checkpoint.loadedFiles - downloadCheckpoints[checkpointIndex-1].loadedFiles;
            timeFromLastCheckpoint = checkpoint.requestTime - downloadCheckpoints[checkpointIndex-1].requestTime;
        }
        else {
            loadedFromLastCheckpoint  = checkpoint.loadedFiles;
            timeFromLastCheckpoint = checkpoint.requestTime;
        }
        
        return new RequestCheckpoint(loadedFromLastCheckpoint, timeFromLastCheckpoint);
    })
    .map((checkpoint) => {
        const 
            loadedFilesInMegabits = checkpoint.loadedFiles * 8 / 1000000,
            requestTimeInSeconds = checkpoint.requestTime / 1000;

        return loadedFilesInMegabits / requestTimeInSeconds;
    });
}